export const linkTagRegEx = /<\/?[a-z][\s\S]*>/i;
export const htmlTagSanityRegEx = /[`$^*()_+=\[\]{};':"\\|<>\/~]/;
